import React, {Suspense} from "react";
import {Switch} from "react-router-dom";
import {LayoutSplashScreen, ContentRoute} from "../../../_metronic/layout";
import {InvitedUsersPage as InvitedUsers} from './pages/InvitedUsersPage';
import {pathNames as P} from '../_common/constants/pathnames';

export default function InvitedUsersPage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <ContentRoute path={P.invitedUsersPage} component={InvitedUsers} />
      </Switch>
    </Suspense>
  );
}
